export default __webpack_public_path__ + "static/media/SneakPeek.181fc0c5.gif";